// extracted by mini-css-extract-plugin
export default {"root":"RemoteAccessForm_root__L-vfW"};